import AScene from "../../library/ExtendedObjects/AScene.js";
import TweensColorPicker from "../TweensFolder/TweensColorPicker.js";
import gameData from "../../gameData.js";
import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../../FontKeys.js";
import ATextButton from "../../library/ExtendedObjects/ATextButton.js";

export default class PickCakeColor extends AScene
{
    /********************************************************/
    /*       The first scene after Intro, color buttons     */
    /*       that change the colors of the cake, and        */
    /*           then transistions to PlaceItems            */
    /********************************************************/

    static get KEY() { return 'PickCakeColor'; }

    create()
    {
        gameData.CakeColor = 0xfaf9eb;
        this.Cake;
        this.Animations = new TweensColorPicker(this);
        this.PlaceAssets();
    }

    PlaceAssets()
    {
        var i; //increment

        var Back = this.addImage(0,0,"Bckg_1");
        Back.setOrigin(0,0);

        var Table = this.addImage(0,768,"UI _ General/Countertop");
        Table.setOrigin(0,1);

        var Plate = this.addImage(this.mid.x, 630, "UI _ General/Asset 184");
        this.Cake = this.addImage(this.mid.x, 474, "UI _ General/MCake");
        this.Cake.setTint(gameData.CakeColor);

        this.Animations.PlateIn(Plate);

        const NextButton = new ATextButton(this, 921, this.mid.y, "Cake Color/Next", null, ()=>{
            this.playSound("button_menu_click");
            this.Animations.TintButtonsOut(TintButton);
            this.Animations.NextButtonOut(NextButton);
            this.Animations.InstructionsOut(Instruction);
        });
        const nextText = ABCyaPhaser.Text.addText(0, -5, 56, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('next'), this,true);

        this.add.existing(NextButton);

        const nextBack = NextButton.backImage;

        ABCyaPhaser.Text.resizeFontToFitWidth(nextText, nextBack.width, nextBack.height - 18);


        nextText.setShadow(-2, 0, '#f58820', 0, true, true);
        NextButton.add(nextText);
        NextButton.setVisible(false);

        const Instruction = ABCyaPhaser.Text.addText(this.mid.x, 45, 42, 0xfffce9, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('cake_color'), this, true); 
        Instruction.setShadow(-2, 0, '#5b2ea3', 0, true, true);
        Instruction.setVisible(false);
        
        var TintButton = [];

        for (i=0; i<10;i++)
        {
            TintButton[i] = this.addImage(107 + (i* 90),120, "Cake Color/Clr_"+(i+1));
            TintButton[i].setScale(0);
            TintButton[i].number = i;
            TintButton[i].on('pointerdown',function()
            {
                this.scene.SetCakeTint(this.number);
            });
            TintButton[i].setInteractive();
        }

        for (i=10; i<20;i++)
        {
            TintButton[i] = this.addImage(107 + ((i-10)* 90),220, "Cake Color/Clr_"+(i+1));
            TintButton[i].setScale(0);
            TintButton[i].number = i;
            if(i === 15)TintButton[i].setTint(0xfaf9eb);

            TintButton[i].on('pointerdown',function()
            {
                this.scene.SetCakeTint(this.number);
            });
            TintButton[i].setInteractive();
        }

        this.Animations.FallingInTween(this.Cake, TintButton);
        this.addDelay(800,()=>{
            this.Animations.InstructionsIn(Instruction);
            this.Animations.NextButtonIn(NextButton);
        });
    }

    SetCakeTint(Number)
    {
        const TintList =
                [
                    0xfedc4b,//18 1
                    0xf9af1e,//19 2
                    0xff8c3d,//20 3
                    0xef4f3b,//17 4
                    0xc32139,//16 5
                    0xff97d0,//15 6
                    0xff5cae,//14 7
                    0xdd67f9,//13 8
                    0xa554f7,//12 9
                    0x5f40d3,//11 10
                    0x5e9afc,//6 11
                    0x62d5ef,//10 12
                    0x68f2ee,//9 13
                    0x5ce0be,//8 14
                    0x88d159,//7 15
                    0xfaf9eb,//1 16
                    0xfcb984,//5 17
                    0xca6c15,//4 18
                    0x7c3f09,//3 19
                    0x424242,//2 20   
                ];

        if (gameData.CakeColor != TintList[Number])
        {
            this.playSound('button_menu_click');
            this.Cake.setTint(TintList[Number]);
            gameData.CakeColor = TintList[Number];
        }
    }
}